import { CUSTOMER_APIS } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";
import { IVaccinationHistoryResponse } from "@/api_framework/api_modals/Vaccination";
import { setVaccinationData } from "@/app_redux/reducers/slices/auth/customer_profile_slice";

AxiosCurlirize(axios, () => {});

export const usePetWiseVaccinationListAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const [staticData, setStaticData] = useState([]);

  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (pet_species_id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response = await axios
          .get(`${CUSTOMER_APIS?.PET_WISE_VACCINATION?.baseURL}?pet_species_id=${pet_species_id}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IVaccinationHistoryResponse>) => {
            if (res.data.status === true) {
              setStaticData(res.data.data);
              return { status: true, message: null };
            } else {
              setStaticData([]);
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            setStaticData([]);
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            const message = e.response.data as any;
            return { status: false, message: message.message };
          });
        return response;
      } catch (e: any) {
        captureError(e);
      }
    },
    [dispatch],
  );
  return { execute, staticData };
};
